export default function test(str) {
    if (str) if (str.length < 10) return "Ten characters minimum";
    return true;
}